export default __webpack_public_path__ + "a0c6a229e93e8a1c096676c19aef1447.png";